import { Controller } from 'stimulus'
import 'nodelist-foreach-polyfill'

export default class extends Controller {
  static targets = ['mainItem', 'thumbItem']

  change(event) {
    const index = Number(event.target.dataset.index)

    this.mainItemTargets.forEach((_main, _index) => {
      if (index == _index) {
        _main.classList.add('-current')
      } else {
        _main.classList.remove('-current')
      }
    })

    this.thumbItemTargets.forEach((_thumb, _index) => {
      if (index == _index) {
        _thumb.classList.add('-current')
      } else {
        _thumb.classList.remove('-current')
      }
    })
  }
}